module.exports = __webpack_public_path__ + "img/back_m2.14179830.png";